
import {Database, GitBranch, Hash, Info, Shield} from "react-feather";
import { PiScroll } from "react-icons/pi";

const TopMenu = ({audience}) => {
    const output = {
        items: [
            {
                path : '/audiences/:id',
                icon : <Info/>,
                label: 'Info',
                slug : 'edit'
            },
        ]
    }

    if (audience) {
        output.items.push({
                path : '/audiences/:id/fields',
                icon : <Hash/>,
                label: 'Fields',
                slug : 'fields'
            },
            {
                path : '/audiences/:id/segments',
                icon : <GitBranch/>,
                label: 'Segments',
                slug : 'segments',
                paths: [
                    '/audiences/:id/segments/create',
                    '/audiences/:id/segments/:id2/edit',
                ]
            },
            {
                path : '/audiences/:id/entities',
                icon : <Database/>,
                label: 'Entities',
                slug : 'entities'
            }
        )

        if (audience?.Account?.Plan?.features?.use_robinson === "on") {
            output.items.push({
                path : '/audiences/:id/robinson',
                icon : <Shield/>,
                label: 'Robinson',
                slug : 'robinson'
            })
        }

        if (audience?.Account?.Plan?.features?.use_consents === "on") {
            output.items.push({
                path : '/audiences/:id/consent-types',
                icon : <PiScroll style={{height: '25px'}} />,
                label: 'Consents',
                slug : 'consent-types'
            })
        }
    }

    return output

}

export default TopMenu
